import React from 'react'
import createReactClass from 'create-react-class'
import MonitoringFormPanel from './monitoring-form-panel'
import SearchResult from '../search-page/search-result'
import NewPortfolioPanel from '../new-portfolio-panel'
import './monitoring-panel.scss'

export default createReactClass({
  createPortfolio (name) {
    this.props.createPortfolio(name)
  },

  render () {
    return (
      <div className="search-panel">
        <div className="csc-panel">
          <div className="panel-body">
            <h4 className="card-title">Portfolios
              <NewPortfolioPanel onCreate={this.createPortfolio} isCreated={this.props.isPortfolioCreated}
                error={this.props.modalError} onModalClose={this.props.resetError}/>
            </h4>
            <MonitoringFormPanel {...this.props}/>
          </div>
        </div>
        <div className="csc-panel">
          <div className="panel-body">
            <h4 className="card-title">Companies</h4>
            <SearchResult {...this.props} isMonitoring={true}/>
          </div>
        </div>
      </div>
    )
  },
})



// WEBPACK FOOTER //
// ./src/components/monitoring-page/monitoring-panel.js